(function () {
  'use strict';

  /* @ngdoc object
   * @name finance.vcunicat
   * @description
   *
   */
  angular
    .module('vcfinance.unicat', [
    ]);
}());
